import { replaceOperation } from '../../product/operations';
import { editVideos } from '../videos';

import { EMPTY } from '../../../constants';

export function videos({ operation, product, ...rest }) {
  const value = operation.get('value');
  const updates = editVideos({ product, value });

  return {
    ...rest,
    product: updates.product.set('operations',
      updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
    ),
  };
}
